import { BottomNavigation, BottomNavigationAction, Paper } from '@mui/material'
import { useLocation, useNavigate } from 'react-router'
import { useTranslation } from 'react-i18next'
import { useAuthStore } from '@/features/auth'
import { getVisibleNavItems } from './navItems'

const BottomNav = () => {
    const { pathname } = useLocation()
    const navigate = useNavigate()
    const { t } = useTranslation()
    const { userProfile } = useAuthStore()

    const items = getVisibleNavItems(userProfile?.roles).filter((item) => !item.disabled)
    const currentPath = items.some((item) => item.path === pathname) ? pathname : items[0]?.path

    return (
        <Paper
            elevation={0}
            sx={{
                position: 'fixed',
                bottom: 0,
                left: 0,
                right: 0,
                borderTop: '1px solid rgba(0, 0, 0, 0.12)',
                zIndex: (theme) => theme.zIndex.appBar,
            }}
        >
            <BottomNavigation
                value={currentPath}
                onChange={(_, newValue: string) => {
                    navigate(newValue)
                }}
            >
                {items.map((item) => (
                    <BottomNavigationAction
                        key={item.path}
                        value={item.path}
                        label={t(item.labelKey)}
                        icon={<img src={item.icon} alt="" style={{ width: 20, height: 20, filter: 'invert(29%)' }} />}
                    />
                ))}
            </BottomNavigation>
        </Paper>
    )
}

export default BottomNav
